import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Api from "../../../services/ServiceApi";
import axios from "axios";
import { connect } from "react-redux";
import Dashboard from "../../../components/Table_Monitor/Dashboard";

function DashboardMonitor({ lastDashboardUpdate }) {
  const { company } = useParams() || {};
  const companyName = company?.toLowerCase();

  const getAuthByName = {
    uih: {
      companyId: 3,
      operatorId: 3,
      projectId: 5,
    },
    dtac: {
      companyId: 3,
      operatorId: 4,
      projectId: 6,
    },
  };
  const title = "Ticket monitor";
  const configComponent = {
    table_stoptime: {
      visible: true,
    },
    table_request_inservice: {
      visible: true,
    },
    table_customer_clear: {
      visible: true,
    },
    table_alarm_clear: {
      visible: true,
    },
  };
  const [masterLang, setmasterLang] = useState([]);
  const [factUpdate, setfactUpdate] = useState(false);
  useEffect(() => {
    let fetchSuccess = false;
    if (!fetchSuccess) {
      axios
        .all([
          Api.post("master_language_detail_get", {
            company_id: getAuthByName[companyName]?.companyId,
            page_id: 1,
          }),
        ])
        .then(([resMasterLangData]) => {
          const {
            result: resultMasterLang,
            data: dataMasterLangData,
          } = resMasterLangData.data;

          if (resultMasterLang?.code === "P") {
            setmasterLang(
              JSON.parse(
                dataMasterLangData["masteR_LANGUAGE_DETAIL"][0].file_json
              )
            );
            setfactUpdate(true);
          }
        });
    }
    return () => {
      fetchSuccess = true;
    };
  }, []);
  return (
    <div className="bbtec-theme">
      <div className="uih-dashboard-fullscreen">
        <Dashboard
          title={title}
          CompanyId={getAuthByName[companyName]?.companyId}
          OperatorId={getAuthByName[companyName]?.operatorId}
          ProjectId={getAuthByName[companyName]?.projectId}
          masterLang={masterLang}
          factUpdate={factUpdate}
          lastDashboardUpdate={lastDashboardUpdate}
          configComponent={configComponent}
          view_mode={"monitor"}
        ></Dashboard>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  lastDashboardUpdate: state.metaData.lastDashboardUpdate,
});
export default connect(mapStateToProps)(DashboardMonitor);
